import React from 'react';
import { Coffee, Utensils, Wine, ShoppingBag } from 'lucide-react';

const FoodSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  // Описания уровней питания
  const foodOptions = {
    'budget': {
      name: 'Бюджетное',
      description: 'Питание в недорогих заведениях, уличная еда, самостоятельное приготовление. Около 800 ₽ на человека в день.',
      icon: <Coffee className="w-5 h-5 text-yellow-500" />
    },
    'moderate': {
      name: 'Среднее',
      description: 'Сочетание кафе среднего уровня и ресторанов. Около 1500 ₽ на человека в день.',
      icon: <Utensils className="w-5 h-5 text-orange-500" />
    },
    'premium': {
      name: 'Премиум',
      description: 'Питание в хороших ресторанах, гастрономические опыты. От 3000 ₽ на человека в день.',
      icon: <Wine className="w-5 h-5 text-red-500" />
    }
  };

  // Получить информацию о текущем выбранном уровне питания
  const currentFoodOption = foodOptions[formData.foodOption] || foodOptions.moderate;

  return (
    <div className="mb-6 bg-yellow-50 dark:bg-yellow-900/20 p-4 rounded-lg border border-yellow-200 dark:border-yellow-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        {currentFoodOption.icon}
        <span className="ml-2">Питание</span>
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Уровень питания */}
        <div className="col-span-full">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Выберите уровень питания
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
            {Object.entries(foodOptions).map(([key, option]) => (
              <label 
                key={key}
                className={`
                  flex flex-col items-center justify-center p-3 rounded-lg border
                  ${formData.foodOption === key 
                    ? 'bg-yellow-100 border-yellow-300 text-yellow-700 dark:bg-yellow-900/40 dark:border-yellow-700 dark:text-yellow-300'
                    : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-650'}
                  transition-colors cursor-pointer
                `}
              >
                <input
                  type="radio"
                  name="foodOption"
                  value={key}
                  checked={formData.foodOption === key}
                  onChange={handleInputChange}
                  className="sr-only"
                />
                <div className="mb-2">
                  {option.icon}
                </div>
                <span className="text-sm font-medium">{option.name}</span>
              </label>
            ))}
          </div>
          {errors.foodOption && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.foodOption}
            </p>
          )}
        </div>

        {/* Самостоятельное приготовление еды */}
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="selfCatering"
              checked={formData.selfCatering}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <div className="ml-2">
              <span className="text-sm text-gray-700 dark:text-gray-300">
                Готовить самостоятельно
              </span>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Экономия до 30% на питании
              </p>
            </div>
          </label>
        </div>

        {/* Напитки и алкоголь */}
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="includeDrinksAndAlcohol"
              checked={formData.includeDrinksAndAlcohol}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <div className="ml-2">
              <span className="text-sm text-gray-700 dark:text-gray-300">
                Учитывать напитки и алкоголь
              </span>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Дополнительно ~40% к стоимости питания
              </p>
            </div>
          </label>
        </div>
      </div>

      {/* Информация о выбранном уровне питания */}
      <div className="mt-4 bg-white dark:bg-gray-700 p-3 rounded-lg border border-yellow-100 dark:border-yellow-800">
        <div className="flex items-start">
          {currentFoodOption.icon}
          <div className="ml-3">
            <h4 className="text-sm font-medium text-gray-900 dark:text-white">
              {currentFoodOption.name} питание
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
              {currentFoodOption.description}
            </p>
            {formData.selfCatering && (
              <div className="flex items-center mt-2">
                <ShoppingBag className="w-4 h-4 text-green-500 mr-1" />
                <p className="text-xs text-green-600 dark:text-green-400">
                  Самостоятельное приготовление значительно снизит расходы на питание
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodSection;